// src/components/menu/StageMenuItem.jsx
import React, { Component } from 'react';

export default class StageMenuItem extends Component {
  render() {
    const { label, icon, isActive, isDisabled, onClick, onClose, disabledReason, onDisabledInfo } = this.props;

    if (isDisabled) {
      return (
        <div
          className="menu-item menu-item--disabled"
          role="button"
          tabIndex={0}
          aria-disabled="true"
          title={disabledReason || 'In development'}
          onClick={() => onDisabledInfo?.(disabledReason || `${label} is not available yet.`)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onDisabledInfo?.(disabledReason || `${label} is not available yet.`);
            }
          }}
        >
          <span className="menu-icon">
            <img className="icon-img" src={icon} alt="" />
          </span>
          <span className="menu-label">
            {label}
            <span className="dev-badge">Soon</span>
          </span>
        </div>
      );
    }

    return (
      <div
        className={`menu-item ${isActive ? 'active' : ''}`}
        onClick={() => { 
          onClick(label); 
          onClose && onClose(); 
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClick(label);
            onClose && onClose();
          }
        }}
        aria-current={isActive ? 'page' : undefined}
      >
        <span className="menu-icon">
          <img className="icon-img" src={icon} alt="" />
        </span>
        <span className="menu-label">{label}</span>
      </div>
    );
  }
}
